/** Optional shelf-audit walk filter. Height is the last shelf-index segment (`1-A-2` → 2). */

export const SHELF_AUDIT_HEIGHT_LIMITS = {
  low: 'low',
  high: 'high',
} as const;

export type ShelfAuditHeightLimit =
  (typeof SHELF_AUDIT_HEIGHT_LIMITS)[keyof typeof SHELF_AUDIT_HEIGHT_LIMITS];

export const SHELF_AUDIT_HEIGHT_BANDS: Record<
  ShelfAuditHeightLimit,
  { readonly min: number; readonly max: number }
> = {
  low: { min: 1, max: 4 },
  high: { min: 5, max: 6 },
};
